import { BlogAnchor } from "./BlogAnchor";

/** `<BlogLink slug label />`: inline link to /blog/{slug}. Tracked inside BlogAnchor. */
export function BlogLink({ slug, label }: { slug: string; label: string }) {
  return <BlogAnchor href={`/blog/${encodeURIComponent(slug)}`}>{label}</BlogAnchor>;
}

export default BlogLink;
